import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import InputFile from '@app/components/input-file/InputFile';
import Editor from '@app/components/editor/Editor';
import { Post } from '@app/utils/httpProvider';
import { ROLE_API } from '@app/utils/apiUrl';
import { useMutation } from 'react-query';
import {
    messageError,
    messageToast,
    acceptImage,
    objectDataTypeCategory,
    styleSelectDefault,
    styleSelectError,
    status200
} from '../../utils/define';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    name: yup.string().required(messageError.emptyMessage),
});

const RoleAdd = () => {
    const history = useHistory();

    // const {isLoading, isError, error, data} = useQuery(['cateData'], () =>
    //     Get(CATEGORY_API.GET_ALL_CATEGORY, null)
    // );

    const addFunc = useMutation((value) =>
        Post(ROLE_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = { ...values };
        // model.parentId = values.parentId === 'null' ? '' : values.parentId;
        // model.parentId = '';

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    // if (isLoading) return 'Loading...';

    // if (isError) return `An error has occurred: ${error.message}`;

    // let listMenu = [
    //     {
    //         name: 'Danh mục gốc',
    //         id: 'null',
    //         parentId: NIL_UUID
    //     }
    // ];

    // listMenu = listMenu.concat(data.data.$values);

    return (
        <Card>
            <Card.Header as="h5">Thêm danh mục</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        name: '',
                        parentId: '',
                        description: '',
                        orderNumber: 0,
                        roleCode: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên quyền',
                                        name: 'name',
                                        value: values.name,
                                        onChange: handleChange,
                                        isInvalid: errors.name,
                                        error: errors.name
                                    },
                                    {
                                        label: 'Thứ tự',
                                        name: 'orderNumber',
                                        value: values.orderNumber,
                                        onChange: handleChange,
                                        isInvalid: errors.orderNumber,
                                        error: errors.orderNumber,
                                        type: "number"
                                    }
                                ]}
                            />
                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Mã quyền *
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                placeholder="Mã quyền"
                                                type="text"
                                                name="roleCode"
                                                value={values.roleCode}
                                                onChange={handleChange}
                                                isInvalid={!!errors.roleCode}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.roleCode}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Mô tả
                                        </Form.Label>
                                        <Col sm="10">
                                            <Col sm="10">
                                                <Editor
                                                    name="description"
                                                    value={values.description}
                                                    onChange={(value) => {
                                                        setFieldValue(
                                                            'description',
                                                            value
                                                        );
                                                    }}
                                                />
                                            </Col>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() =>
                                                history.goBack()
                                            }
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {/* <ReactSpinner loadings={isLoading} /> */}
            </Card.Body>
        </Card>
    );
};

export default RoleAdd;
